query onofficeConfig($companyId: ID!) {
  onofficeConfig(companyId: $companyId) {
    token
    isTokenVerified
    selectedContactTypes
    isManagedBySharedConfig
  }
}
